import styled, { keyframes } from "styled-components";

import Unit from "./Unit";
import getPositionsArray from "./../Canvas/unitPositionsArray";
import { entranceDelay } from "./../Canvas/styles/EntranceImage";

const entrance = keyframes`
    0% {
        filter: invert(100%);
        opacity: 0;
    }
    75% {
        filter: invert(100%);
        opacity: 0;
    }
    100% {
        filter: invert(0%);
        opacity: 1;
    }
`;

const exit = keyframes`
    0% {
        filter: invert(0%);
    }
    50% {
        filter: invert(50%);
        opacity: 1;
    }
    100% {
        filter: invert(100%);
        opacity: 0;
    }
`;

export const CanvasUnit = styled(Unit)`
    animation: ${entrance} 1 ${(entranceDelay / 2) / 1000}s ease-in-out;
    position: absolute;
    left: ${props => getPositionsArray(props.currentTheme)[props.location].left};
    top: ${props => getPositionsArray(props.currentTheme)[props.location].top};
    height: ${props => props.imageSize}px;
    width: ${props => props.imageSize}px;
    ${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? "min-height: 325px;" : null}
    ${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? "min-width: 325px;" : null}

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        position: relative;
        left: unset;
        top: unset;
    }
`;

CanvasUnit.displayName = "CanvasUnit";

export const RemoveUnit = styled(CanvasUnit)`
    animation: ${exit} 1 0.75s ease-in-out;
`;

RemoveUnit.displayName = "RemoveUnit";
